<template>
  <span class="n-icon">
    <svg :style="{ fill: fill }" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.002 19.146">
      <path
        d="M9.85 19.146c-1.13 0-2.229-.46-3.02-1.26L.724 11.697c-.974-.989-.964-2.581.024-3.555.989-.975 2.582-.965 3.555.023l5.541 5.617L22.697.749c.976-.989 2.567-1 3.557-.024.987.975.998 2.567.024 3.556L12.861 17.885c-.787.799-1.885 1.26-3.011 1.261z"
      /></svg
  ></span>
</template>

<script lang="ts" setup>
defineProps({
  fill: {
    type: String,
    default: 'currentColor',
  },
});

defineOptions({
  name: 'n-tick-icon',
});
</script>
